/*@ngInject*/
const PolicyActionRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.reinstatePolicy = function (policyId,reason, detail) {
        var url = '/rest/Policy/' + policyId + '/reinstateById',
            config = {
                params: {
                    reason: reason,
                    detail:detail,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.startPolicyCancellation = function (policyId) {
        var url = '/rest/Policy/' + policyId + '/startCancellation';

        return this.post(url);
    };

    this.deleteDraftCancellation = function (policyCancellationId) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId;

        return this.delete(url);
    };

    this.markAsCancelled = function (policyCancellationId) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/markAsCancelled',
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.requestCancellation = function (policyCancellationId) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/request',
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.rescindCancellation = function (policyCancellationId, reason, detail) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/rescind',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.retractCancellationRequest = function (policyCancellationId, reason, detail) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/retractRequest',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.revertToCancellationPending = function (policyCancellationId, reason, detail) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/revertToCancellationPending',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.submitForCancellation = function (policyCancellationId) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/submit',
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.beginIssuance = function (policyIssuanceId) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/startIssuance';

        return this.post(url);
    };

    this.markAsIssued = function (policyIssuanceId) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/markAsIssued';

        return this.post(url);
    };

    this.modifyIssuance = function (policyIssuanceId) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/modifyIssuance';

        return this.post(url);
    };

    this.revertToBound = function (policyIssuanceId, reason, detail) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/revertToBound',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                }
            };

        return this.post(url, {}, config);
    };

    this.revertToPendingIssuance = function (policyIssuanceId, reason, detail) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/revertToPendingIssuance',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                }
            };

        return this.post(url, {}, config);
    };

    this.submitForIssuance = function (policyIssuanceId) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/submitForIssuance';

        return this.post(url);
    };

};

angular.module('gw-um-submission')
    .service('policyActionRepository', PolicyActionRepository);
